import base from "./base";
import dev from "./dev";
import local from "./local";
import qa from "./qa";
import uat from "./uat";
import prod from "./prod";
import debug from "debug";

let environment: typeof base;
const log = debug("qap-web:env");

switch (window.location.hostname) {
  case "localhost":
    log("local env loaded");
    environment = { ...base, ...local };
    break;
  case "dev.qap.wiley.host":
    log("dev env loaded");
    environment = { ...base, ...dev };
    break;
  case "qa.qap.wiley.host":
    log("qa env loaded");
    environment = { ...base, ...qa };
    break;
  case "uat.qap.wiley.host":
    log("uat env loaded");
    environment = { ...base, ...uat };
    break;
  case "qap.wiley.host":
    log("prod env loaded");
    environment = { ...base, ...prod };
    break;
  default:
    log(`${window.location.hostname} not a recognized host - dev loaded`);
    environment = { ...base };
}

const env = environment;
export default env;
